import { extendPaletteWithChannels } from 'utils/colorUtils';

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export function buildPalette() {
  const basePalette = {
    primary: {
      lighter: '#eef2f7',
      100: '#e3e9f2',
      200: '#d2dbe8',
      light: '#bcc8d9',
      400: '#8b9ab1',
      main: '#111827',
      dark: '#0d1422',
      700: '#0b1220',
      darker: '#060c16',
      900: '#040912',
      contrastText: '#ffffff'
    },
    secondary: {
      lighter: '#f6efe6',
      100: '#f0e7dc',
      200: '#e5d8c8',
      light: '#d4c3ae',
      400: '#b9a58c',
      main: '#a89379',
      600: '#89745e',
      dark: '#685746',
      800: '#4d4034',
      darker: '#372d24',
      A100: '#fffdfa',
      A200: '#eadfce',
      A300: '#cbb79c',
      contrastText: '#111827'
    },
    info: {
      lighter: '#eef2f7',
      light: '#d9e2ee',
      main: '#5b6c8f',
      dark: '#43516b',
      darker: '#2f394c',
      contrastText: '#ffffff'
    },
    success: {
      lighter: '#eef8f3',
      light: '#cfe9db',
      main: '#4d7c63',
      dark: '#365a48',
      darker: '#243f33',
      contrastText: '#ffffff'
    },
    warning: {
      lighter: '#fff6eb',
      light: '#f8deb6',
      main: '#c58b47',
      dark: '#9b6730',
      darker: '#744a20',
      contrastText: '#111827'
    },
    error: {
      lighter: '#fff1f0',
      light: '#f8c9c4',
      main: '#c36b61',
      dark: '#934b43',
      darker: '#69332d',
      contrastText: '#ffffff'
    },
    grey: {
      0: '#fffdfa',
      50: '#f6efe6',
      100: '#efe7dc',
      200: '#e2d6c7',
      300: '#d2c1ae',
      400: '#bba691',
      500: '#9f8871',
      600: '#816a54',
      700: '#63503f',
      800: '#44372c',
      900: '#2b241d',
      A50: '#fbf6ef',
      A100: '#f2e9dd',
      A200: '#e4d6c2',
      A400: '#ceb79a',
      A700: '#ab8f70',
      A800: '#866d54'
    }
  };

  const commonColor = { common: { black: '#111827', white: '#ffffff' } };

  const extendedLight = extendPaletteWithChannels(basePalette);
  const extendedCommon = extendPaletteWithChannels(commonColor);

  return {
    light: {
      mode: 'light',
      ...extendedCommon,
      ...extendedLight,
      text: {
        primary: extendedLight.grey[700],
        secondary: extendedLight.grey[500],
        disabled: extendedLight.grey[400]
      },
      action: { disabled: extendedLight.grey[300] },
      divider: extendedLight.grey[200],
      background: {
        paper: '#fbf6ef',
        default: extendedLight.grey[50]
      }
    }
  };
}
